<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">FASI DI LAVORO</h1>
    </div>

    <!--********** CAMPO DI RICERCA **********-->
    <div class="columns is-mobile is-centered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-1">
            <div class="control">
                <button class="button" :class="props.soloGiorniSquadra? 'is-primary' : ''" title="Solo giorni-squadra" @click="bToggleSoloGS()">
                    <span class="icon"><i class="fas fa-person-digging"></i></span>
                </button>
            </div>
        </div>
        <div class="column is-5">
            <div class="control">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
            </div>
        </div>
    </div>

    <!--********** TABELLA FASI **********-->
    <div class="blocco-scroll">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <!-- <th class="prima-riga" colspan="6"> -->
                    <th class="prima-riga" :colspan="mostraInfoSviluppo?'6':'4'">
                    <!-- <th class="prima-riga" colspan="4"> -->
                        <p v-if="props.bottoneAggiungiVisibile==true">
                            + Wiz &nbsp; &nbsp; &nbsp; &nbsp;
                            <button class="button is-primary is-small"  @click="bWizard('caldaia')">Caldaia</button>
                            &nbsp;
                            <button class="button is-primary is-small" @click="bWizard('condizionatore')">Condizionatore</button>
                            &nbsp;
                            <button class="button is-primary is-small" @click="bWizard('fotovoltaico')">Fotovoltaico</button>
                            &nbsp;
                            <button class="button is-primary is-small" @click="bWizard('fotovoltaico AEG')">FV AEG</button>
                            &nbsp;
                            <button class="button is-primary is-small" @click="bWizard('ristrutturazione')">Ristrutturazione</button>
                        </p>
                    </th>
                    <th class="prima-riga"  v-if="props.lavoro==null"></th>
                    <th colspan="2" class="has-text-centered prima-riga bordi-laterali">Responsabile</th>
                    <th colspan="3" class="has-text-centered prima-riga bordi-laterali">Giorni-squadra</th>
                    <th class="prima-riga" v-if="props.lavoro!=null"></th>
                </tr>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaFase(-1)" v-if="props.bottoneAggiungiVisibile==true">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th>
                    <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th>
                    <th v-if="props.lavoro==null">Lavoro</th>
                    <th class="has-text-centered">Stato</th>
                    <th class="has-text-centered">Categoria</th>
                    <th class="has-text-centered">Oggetto</th>
                    <th>interno</th>
                    <th>esterno</th>
                    <th>stimati</th>
                    <th>impiegati</th>
                    <th>residui</th>
                    <th class="has-text-centered" title="Note">N</th>
                    <th v-if="props.lavoro!=null">Ordine</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(fs, index) in elencoFasi" :key="leggiInfoDB(fs).id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaFase(leggiInfoDB(fs).id, leggiInfoDB(fs).idLavoro, leggiInfoDB(fs).idCliente)">
                            <span class="icon"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{leggiInfoDB(fs).id}}</td>
                    <td v-if="props.lavoro==null"><a @click="emit('elementoSelezionato', {tipo: 'lavoro', idCliente: leggiInfoDB(fs).idCliente, idLavoro: leggiInfoDB(fs).idLavoro})">{{leggiInfoDB(fs).stringaLavoro}}</a></td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="fs.stato" />
                    </td>
                    <td class="has-text-centered">
                        <ComponenteIcona :nome="fs.categoria" />
                    </td>
                    <td>{{fs.oggetto}}</td>
                    <td class="has-text-centered">{{fs.responsabile}}</td>
                    <td class="has-text-centered">{{fs.responsabileEsterno}}</td>
                    <td class="has-text-centered">{{(fs.lavoroStima==0)? '' : fs.lavoroStima}}</td>
                    <td class="has-text-centered">{{(fs.lavoroEseguito==0)? '' : fs.lavoroEseguito}}</td>
                    <td class="has-text-centered">{{lavoroResiduo(fs.lavoroStima, fs.lavoroEseguito)}}</td>
                    <td class="has-text-centered">
                        <ComponenteIcona nome="Nota" :visibileSempre="false" :descrizione="fs.note" />
                    </td>
                    <td class="has-text-centered" v-if="props.lavoro!=null">{{fs.ordine}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <!--********** MESSAGGIO MODALE **********-->

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>
</template>

<script setup>
    import ComponenteIcona from "./ComponenteIcona.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { Timestamp } from "firebase/firestore";
    import { generaIdFase, mostraInfoSviluppo, getValorePerOrdinamento } from "@/code/utilita";
    import { dbClienti, salvaClienteInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB } from "@/code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        cliente: {
            type: Number,
            default: null },
        lavoro: {
            type: Number,
            default: null },
        testoDaCercare: {
            type: String,
            default: null },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true },
        soloGiorniSquadra: {
            type: Boolean,
            default: false },
    });
    // const emit = defineEmits(['faseSelezionata', 'lavoroSelezionato', 'statoInterfacciaCambiato']);
    const emit = defineEmits(['elementoSelezionato', 'statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE

    const testoRicerca = ref(props.testoDaCercare);
    const stringaNumeroRecord = ref("");
    const messaggioModale = ref(null);       // null = Non mostrare il messaggio modale
    
    // SETUP DEL COMPONENTE

    const elencoFasi = computed(()=>{
        let tempElencoFasi = [];
        if (props.lavoro==null) {
            if (props.cliente==null) {
                for(const cl in dbClienti.value){
                    for(const lv in  dbClienti.value[cl].lavori){
                        for(const fs in  dbClienti.value[cl].lavori[lv].fasi){
                            tempElencoFasi.push(dbClienti.value[cl].lavori[lv].fasi[fs]);
                        }
                    }
                }
            } else {
                for(const lv in dbClienti.value[props.cliente].lavori){
                    for(const fs in dbClienti.value[props.cliente].lavori[lv].fasi){
                        tempElencoFasi.push(dbClienti.value[props.cliente].lavori[lv].fasi[fs]);
                    }
                }
            }
        } else {
            const cl = props.cliente;
            const lv = props.lavoro;
            for(const fs in  dbClienti.value[cl].lavori[lv].fasi){
                tempElencoFasi.push(dbClienti.value[cl].lavori[lv].fasi[fs]);
            }
        }
        ordinaElencoFasi(tempElencoFasi);
        filtraElencoElementi(tempElencoFasi, props.testoDaCercare, ['categoria', 'oggetto', 'stato', 'responsabile', 'responsabileEsterno', 'note']);
        return tempElencoFasi;
    });

    // FUNZIONI DEL COMPONENTE

    function bCerca() {
        emit('statoInterfacciaCambiato', {testoRicercaFasi: testoRicerca.value});
    }

    function bSelezionaFase(idFs, idLv, idCl) {
        let tempIdCl;
        let tempIdLv;
        tempIdCl = props.cliente==null ? idCl : props.cliente;
        tempIdLv = props.lavoro==null ? idLv : props.lavoro;
        emit('elementoSelezionato', {
            tipo: 'fase',
            idCliente: tempIdCl,
            idLavoro: tempIdLv,
            idFase: idFs
        });
    }

    // function ordinaElencoFasi(elenco) {
    //     // Ordina elenco
    //     if (props.lavoro==null) {
    //         // Non è stato selezionato un lavoro => ordino per stato e per categoria
    //         elenco.sort( (a, b) => {
    //             let valA = (a.categoria == 'Documentazione') ? 1:
    //                 (a.categoria == 'Lavoro') ? 2:
    //                 3;
    //             let valB = (b.categoria == 'Documentazione') ? 1:
    //                 (b.categoria == 'Lavoro') ? 2:
    //                 3;
    //             return (valB-valA);
    //         });
    //         elenco.sort( (a, b) => {
    //             let valA = (a.stato == 'Eseguito') ? 1:
    //                 (a.stato == 'Non iniziabile') ? 2:
    //                 (a.stato == 'Sospeso') ? 3:
    //                 (a.stato == 'In attesa') ? 4:
    //                 (a.stato == 'In lavorazione') ? 5:
    //                 (a.stato == 'In verifica') ? 6:
    //                 (a.stato == 'Nuovo') ? 7:
    //                 (a.stato == 'Urgente') ? 8:
    //                 7;
    //             let valB = (b.stato == 'Eseguito') ? 1:
    //                 (b.stato == 'Non iniziabile') ? 2:
    //                 (b.stato == 'Sospeso') ? 3:
    //                 (b.stato == 'In attesa') ? 4:
    //                 (b.stato == 'In lavorazione') ? 5:
    //                 (b.stato == 'In verifica') ? 6:
    //                 (b.stato == 'Urgente') ? 7:
    //                 7;
    //             return (valB-valA);
    //         });
    //     } else {
    //         // E' stato selezionato un lavoro => ordino per 'ordine'
    //         elenco.sort( (a, b) => {
    //         return (a.ordine-b.ordine);
    //     });

    //     }
    //     return elenco;
    // }    

    // Dizionari dei pesi (tutto minuscolo per il matching con la funzione di utilità)
    const PESO_STATO_FASE = {
        'urgente': 8,
        'nuovo': 7,
        'in verifica': 6,
        'in lavorazione': 5,
        'in attesa': 4,
        'sospeso': 3,
        'non iniziabile': 2,
        'eseguito': 1
    };

    const PESO_CATEGORIA_FASE = {
        'lavoro': 2,
        'documentazione': 1
        // il default sarà 3
    };

    function ordinaElencoFasi(elenco) {
        if (props.lavoro == null) {
            // Nessun lavoro: Ordine primario per STATO, secondario per CATEGORIA in UN SOLO CICLO
            elenco.sort((a, b) => {
                // 1. Estrazione sicura
                const statoA = getValorePerOrdinamento(a, 'stato', false);
                const statoB = getValorePerOrdinamento(b, 'stato', false);
                
                // 2. Calcolo dei pesi Stato (Default a 7 come nel tuo codice originale)
                const pesoStatoA = PESO_STATO_FASE[statoA] !== undefined ? PESO_STATO_FASE[statoA] : 7;
                const pesoStatoB = PESO_STATO_FASE[statoB] !== undefined ? PESO_STATO_FASE[statoB] : 7;

                // 3. Ordinamento primario per Stato (Decrescente)
                if (pesoStatoA !== pesoStatoB) {
                    return pesoStatoB - pesoStatoA; 
                }

                // 4. Ordinamento secondario (a parità di stato) per Categoria (Decrescente)
                const catA = getValorePerOrdinamento(a, 'categoria', false);
                const catB = getValorePerOrdinamento(b, 'categoria', false);
                
                const pesoCatA = PESO_CATEGORIA_FASE[catA] !== undefined ? PESO_CATEGORIA_FASE[catA] : 3;
                const pesoCatB = PESO_CATEGORIA_FASE[catB] !== undefined ? PESO_CATEGORIA_FASE[catB] : 3;

                return pesoCatB - pesoCatA;
            });

        } else {
            // Lavoro selezionato: Ordine crescente per 'ordine'
            elenco.sort((a, b) => {
                // Assicuriamo che diventino numeri validi per prevenire i NaN
                const ordA = Number(getValorePerOrdinamento(a, 'ordine', false)) || 0;
                const ordB = Number(getValorePerOrdinamento(b, 'ordine', false)) || 0;
                
                return ordA - ordB; // Crescente (dal più piccolo al più grande)
            });
        }

        return elenco;
    }

    function filtraElencoElementi(elencoEl, testo, campi) {
        // Filtra elencoEl cercando il testo nei campi indicati dall'array di stringhe 'campi'
        const tempStringaNumeroRecord = elencoEl.length;
        if ( (testo) && (testo!="") ) {
            for (let i=0; i < elencoEl.length; i++) {
                const regexCerca = new RegExp(testo, 'i');
                let temp = null;
                let pos = -1;
                for (const cc in campi) {
                    if (pos == -1) {
                        if ( Array.isArray(campi[cc]) ) {
                            temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                        } else {
                            temp = elencoEl[i][campi[cc]];
                        }
                        pos = String(temp).search(regexCerca);
                    }
                }
                if (pos == -1) {
                    temp = JSON.stringify(leggiInfoDBRaw(elencoEl[i]));
                    pos = String(temp).search(regexCerca);
                }
                if (pos == -1) {
                    // il testo non è stato trovato in nessun campo
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }
        // Se è selezionato soloGiorniSquadra elimino le fasi senza GS
        if (props.soloGiorniSquadra==true && props.campoRicercaVisibile==true) {
            for (let i=0; i < elencoEl.length; i++) {
                if (!(parseInt(elencoEl[i].lavoroStima)>0) && !(parseInt(elencoEl[i].lavoroEseguito)>0) ){
                    elencoEl.splice(i,1);
                    i--;
                }
            }
        }

        if (elencoEl.length>110){
            elencoEl.splice(100,(elencoEl.length-100));
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }

    function bToggleSoloGS() {
        // Seleziona solo le fasi che contengono Giorni-Squadra
        // props.soloGiorniSquadra? props.soloGiorniSquadra=false : props.soloGiorniSquadra=true;
        emit('statoInterfacciaCambiato', {soloFasiConGiorniSquadra: !props.soloGiorniSquadra});
    }

    function bComandoModale(comando) {
        switch (comando) {
            case 'caldaia':
            case 'condizionatore':
            case 'fotovoltaico':
            case 'fotovoltaico AEG':
            case 'ristrutturazione':
                lanciaWizard(comando);
                messaggioModale.value = null;
                break;
            case 'annulla':
                messaggioModale.value = null;
        }
    }

    function bWizard(oggetto) {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando: 'annulla'},
            testoPrimary:{testo:'Ok', comando: oggetto},
            testoDanger:null,
            messaggio:"Stai per caricare tutte le fasi di lavoro per " + oggetto };
    }

    function lavoroResiduo(lvStimato, lvEseguito) {
        let lvResiduo = lvStimato-lvEseguito;
        if (lvResiduo>0) {
            return lvResiduo;
        } else if (lvResiduo==0) {
            return '';
            // if (lvStimato>0) {
            //     return lvResiduo;
            // } else {
            //     return '';
            // }
        } else if (lvStimato>0) {
            return lvStimato;
        } else {
            return '';
        }
    }

    async function lanciaWizard(oggetto) {

        let idPrimaFase = generaIdFase(props.cliente, props.lavoro);
        let tempCliente = {}
        aggiungiInfoDB(tempCliente, {
            id: props.cliente
        });
        tempCliente.lavori = {};
        tempCliente.lavori[props.lavoro] = {};
        tempCliente.lavori[props.lavoro].fasi = {};

        switch (oggetto) {
            case 'caldaia':
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Richiesta dati anagrafici';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Ordine materiale';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].lavoroStima = 1;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Agiornamento libretto di impianto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Prima accensione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabileEsterno = 'MagiCAT';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Rapporto di efficienza';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Resoconto lavori';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Fatturazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione DiCo';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Dichiarazione IVA agevolata';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Preparazione pacchetto documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Consegna documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                break;
            case 'fotovoltaico':
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Richiesta dati anagrafici';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Ordine materiale';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Adeguamento contatore elettrico';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Apertura pratica e-distribuzione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Aggiornamento Gaudì';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].lavoroStima = 1;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Attivazione off-grid';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Resoconto lavori';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Fatturazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione DiCo';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Chiusura pratica e-distribuzione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Attivazione on-grid';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = "Verbale d'esercizio";
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Accesso CER AEG';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Comunicazione ENEA';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Dichiarazione IVA agevolata';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Preparazione pacchetto documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Consegna documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                break;
            case 'fotovoltaico AEG':
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Richiesta dati anagrafici';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione POS';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].lavoroStima = 1;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione DiCo';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Fatturazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                break;
            case 'ristrutturazione':
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Richiesta dati anagrafici';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione POS';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Ordine materiale';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Marco Cauda';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Progetto pannelli radianti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].lavoroStima = 1;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Agiornamento libretto di impianto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Prima accensione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabileEsterno = 'MagiCAT';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Rapporto di efficienza';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Resoconto lavori';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Fatturazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Marco Cauda';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione DiCo';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Comunicazione ENEA';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Dichiarazione IVA agevolata';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Preparazione pacchetto documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Consegna documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                break;
            case 'condizionatore':
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Richiesta dati anagrafici';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Ordine materiale';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Lavoro';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].lavoroStima = 1;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Resoconto lavori';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Luca Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Estensione garanzia';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Fatturazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Comunicazione f-gas';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Redazione DiCo';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Agiornamento libretto di impianto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Comunicazione ENEA';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Dichiarazione IVA agevolata';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Preparazione pacchetto documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
                idPrimaFase++;
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase] = {};
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].stato = 'Non iniziabile';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].categoria = 'Documentazione';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].oggetto = 'Consegna documenti';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].responsabile = 'Federico Martinetto';
                tempCliente.lavori[props.lavoro].fasi[idPrimaFase].ordine = idPrimaFase*10;
        }
        await salvaClienteInFirestore(tempCliente, Timestamp.now());
    }

</script>

<style>
    .table th.prima-riga {
        border: none;
    }
    .table th.bordi-laterali {
        border-left: 1px solid #dbdbdb;
        border-right: 1px solid #dbdbdb;
        /* border-width: 0 0 1px; */
    }
</style>